import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { PillButton } from '../stand_alone/pillButton'

const BackAndNext = ({
  linkNext,
  onClick,
  isDisabled,
}: {
  linkNext?: string
  onClick?: () => void
  isDisabled?: boolean
}) => {
  const navigate = useNavigate()
  return (
    <ButtonContainer>
      <h6 onClick={() => navigate(-1)} style={{ cursor: 'pointer' }}>
        Back
      </h6>
      {linkNext ? (
        <PillButton title="Next" link={linkNext} isDisabled={isDisabled} />
      ) : (
        <PillButton title="Next" onClick={onClick} isDisabled={isDisabled} />
      )}
    </ButtonContainer>
  )
}

const ButtonContainer = styled.div`
  display: flex;
  gap: 48px;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
`

export default BackAndNext
